import axios from 'axios'

const apiPayment = axios.create({
	baseURL: '/api/payment'
})

export default apiPayment
